var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5452 15.5458C15.0249 16.0634 14.7312 16.7662 14.7285 17.5C14.7285 18.2349 15.0204 18.9396 15.5401 19.4593C16.0597 19.9789 16.7645 20.2708 17.4993 20.2708C18.2332 20.2681 18.936 19.9744 19.4535 19.4542",
    stroke: "#741374",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.1875C15.8559 9.1875 14.2488 9.67502 12.8818 10.5884C11.5148 11.5018 10.4494 12.8 9.82026 14.3189C9.1911 15.8379 9.02649 17.5092 9.34723 19.1217C9.66797 20.7342 10.4597 22.2153 11.6222 23.3778C12.7847 24.5403 14.2658 25.332 15.8783 25.6528C17.4908 25.9735 19.1621 25.8089 20.6811 25.1797C22.2 24.5506 23.4982 23.4852 24.4116 22.1182C25.325 20.7512 25.8125 19.1441 25.8125 17.5",
    stroke: "#741374",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 3.64581C14.7596 3.64581 12.081 4.45835 9.80272 5.98066C7.52441 7.50298 5.74869 9.6667 4.7001 12.1982C3.65151 14.7297 3.37715 17.5153 3.91172 20.2028C4.44628 22.8902 5.76577 25.3588 7.70331 27.2964C9.64085 29.2339 12.1094 30.5534 14.7969 31.0879C17.4843 31.6225 20.2699 31.3482 22.8014 30.2996C25.333 29.251 27.4967 27.4752 29.019 25.1969C30.5413 22.9186 31.3538 20.2401 31.3538 17.5M22.6403 12.3608L18.8851 16.1146",
    stroke: "#741374",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5375 8.52251L25.8125 9.18751L26.4775 4.46251C26.4823 4.40762 26.4707 4.35253 26.4442 4.30427C26.4176 4.25601 26.3772 4.21678 26.3282 4.19157C26.2792 4.16637 26.2238 4.15635 26.1691 4.16279C26.1144 4.16922 26.0628 4.19183 26.021 4.22771L22.8885 7.34417C22.5667 7.66824 22.3301 8.06682 22.1996 8.50443C22.069 8.94204 22.0487 9.40514 22.1404 9.85251L22.6391 12.3608L25.1475 12.8581C25.5948 12.9498 26.0579 12.9295 26.4955 12.7989C26.9331 12.6684 27.3317 12.4318 27.6558 12.11L30.7708 8.97897C30.8068 8.93706 30.8295 8.88536 30.8359 8.83048C30.8423 8.7756 30.8321 8.72006 30.8067 8.67099C30.7813 8.62193 30.7418 8.58157 30.6933 8.55511C30.6448 8.52865 30.5895 8.5173 30.5345 8.52251",
    stroke: "#741374",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.a7ca9e71f5d5d070d7e8fcdf5a5443f3.svg";
export { ForwardRef as ReactComponent };